<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import reportSwitch from './reportSwitch';
import googleads from '@/backend/services/googleAds/googleAds.js';

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let {
		templateList,
		monthlyReportTemplateId,
		monthlyReportOpen,
		weekReportTemplateId,
		weekReportOpen,
		weekReportSendOpen,
	} = attributes;
	return {
		monthlyReport: {
			label: '自动月报',
			formType: reportSwitch,
			value: [monthlyReportOpen || false, monthlyReportTemplateId],
			options: templateList,
			props: {
				label: 'name',
				value: 'id',
			},
		},
		weekReport: {
			label: '自动周报',
			formType: reportSwitch,
			value: [weekReportOpen || false, weekReportTemplateId],
			options: templateList,
			props: {
				label: 'name',
				value: 'id',
			},
		},
		weekReportSendOpen: {
			label: '周报是否发送',
			formType: 'sky-switch',
			value: weekReportSendOpen || false,
			visable(vm) {
				return vm.formData.fields.weekReport.value[0] === true;
			},
		},
	};
}

async function submit(data) {
	try {
		let { attributes } = this;
		let { serviceId } = attributes;
		let { monthlyReport, weekReport } = data;
		data.monthlyReportOpen = monthlyReport[0];
		data.monthlyReportTemplateId = monthlyReport[1];
		data.weekReportOpen = weekReport[0];
		data.weekReportTemplateId = weekReport[1];
		delete data.monthlyReport;
		delete data.weekReport;
		await googleads.addTemplateRelation({
			...data,
			serviceId,
		});
		this.$message.success('编辑成功');
		this.$emit('confirm');
	} catch (error) {
		this.$message.error('编辑失败');
		this.formData.loading = false;
	}
}

function cancel(self) {
	self.$emit('cancel');
}

async function onShowLoad(props) {
	let { data: templateList } = await googleads.templateChooseList();
	return {
		...props,
		templateList,
	};
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		labelWidth: '100px',
	}
);

export default formDialogCreate({
	name: 'myClientEdit',
	onShowLoad,
	componentForm,
});
</script>

<style scoped lang="scss"></style>
